export const splitName = (name: string, partOfName: string) => {
  if (!name) return '';

  const fullName = name?.split(' ');

  if (partOfName === 'firstName') {
    return fullName[0];
  }

  if (partOfName === 'lastName') {
    return fullName[fullName.length - 1];
  }

  if (partOfName === 'firstAndLast') {
    const first = fullName[0];
    const last = fullName[fullName.length - 1];

    const firstAndLast = [first, last];

    return firstAndLast.join(' ');
  }

  fullName.shift();

  return fullName.join(' ');
};

export const getUserStatus = (status: string) => {
  if (status === 'US1') {
    return 'Concluído';
  }
  if (status === 'US2') {
    return 'Desativado';
  }
  return 'Pendente';
};

export const getUserProfile = (profile: string) => {
  if (profile === 'BMS1') {
    return 'Admin';
  }
  return 'Membro';
};

export const getNumberOfUsers = (usersAmount: number) => {
  if (usersAmount <= 0) return 'Nenhum usuário';
  if (usersAmount === 1) return '1 usuário';
  return `${usersAmount} usuários`;
};

export const getNumberOfEnterprises = (enterprisesAmount: number) => {
  if (enterprisesAmount <= 0) return 'Nenhum empresa';
  if (enterprisesAmount === 1) return '1 empresa';
  return `${enterprisesAmount} empresas`;
};

export const getNumberOfUsersRegistered = (usersAmount: number) => {
  if (usersAmount <= 0) return 'Nenhum usuário cadastrado';
  if (usersAmount === 1) return '1 usuário cadastrado';
  return `${usersAmount} usuários cadastrados`;
};
